import { CartQueryShippingAddress } from '@app/types/monolith/types';
import { IntlShape } from '@redbubble/next/intl';
import { DeviceType } from '@redbubble/next/types';
import {
  ChangeResolveDetails,
  ExpressCheckoutPartialAddress,
  StripeElements,
} from '@stripe/stripe-js';
import { StripeCart } from '../types';
import { updateModalAfterCartRefetch } from './utils';

// https://stripe.com/docs/js/elements_object/express_checkout_element_shippingaddresschange_event

export const handleShippingAddressChange = async (
  address: ExpressCheckoutPartialAddress,
  resolve: (resolveDetails?: ChangeResolveDetails) => void,
  reject: () => void,
  elements: StripeElements,
  onShippingAddressChange: (
    shippingAddress: CartQueryShippingAddress
  ) => Promise<StripeCart>,
  intl: IntlShape,
  isOrAbove: (deviceType: DeviceType) => boolean
): Promise<void> => {
  onShippingAddressChange({
    countryCode: address.country,
    postcode: address.postal_code,
    state: address.state,
  })
    .then((cart) => {
      updateModalAfterCartRefetch(cart, elements, resolve, intl, isOrAbove);
    })
    .catch(() => {
      reject();
    });
};
